import React from 'react';

function lazyLoader(loader) {
  return new Promise((solve) => {
    loader((module) => {
      solve(module.default ? module.default : module);
    });
  });
}

export default {
  namespace: 'switchContainer',
  state: {
    component: {}
  },
  reducers: {
    setComponent(state, { response: component }) {
      return {
        ...state,
        component,
      };
    },
  },
  effects: {
    * change({ payload }, { put, call }) {
      try {
        if (typeof payload === 'function') {
          const Component = yield call(lazyLoader, payload);
          yield put({ type: 'setComponent', response: <Component /> });
        } else {
          yield put({ type: 'setComponent', response: payload });
        }
      } catch (error) {
        yield put({ type: 'setComponent', response: {} });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/common/switchContainer.js